"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onOpenCalendar: function(agenda) {
          if (!this.input.clickable) {
            return;
          }

          window.Extensions.run("Calendar", {
              mode: "view",
              agenda: agenda
            });
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Schedules.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_attrs0 = {
        "class": "schedule-list"
      },
    marko_attrs1 = {
        "class": "px-50"
      },
    marko_attrs2 = {
        "class": "pl-75"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.list) && input.list.length) {
    out.be("div", marko_attrs0, "0", component);

    marko_forOf(input.list, function(agenda, index) {
      const { start, end } = agenda

      var $keyValue$0 = "@" + index,
          $keyScope$0 = "[" + ($keyValue$0 + "]");

      out.be("div", {
          "class": marko_classValue("d-flex align-items-center py-25 " + (input.clickable ? "cursor-pointer" : ""))
        }, $keyValue$0, component, null, 1, {
          onclick: __component.d("click", "onOpenCalendar", false, [
              agenda
            ])
        });

      Bx_tag({
          type: "calendar-check",
          class: "green-text font-medium-5 pr-1"
        }, out, __component, "1" + $keyScope$0);

      if (start && (!isEmpty(start))) {
        out.e("span", null, "2" + $keyScope$0, component, 1)
          .t(start.date + (start.time ? " " + start.time : ""), component);
      }

      if (end && (!isEmpty(end))) {
        out.e("span", null, "3" + $keyScope$0, component, 2)
          .e("span", marko_attrs1, "4" + $keyScope$0, component, 1)
            .t("-")
          .t(end.date + (end.time ? " " + end.time : ""), component);
      }

      if (input.removable) {
        out.be("span", marko_attrs2, "5" + $keyScope$0, component, null, 0, {
            onclick: __component.d("click", () => component.emit('remove', index ), false)
          });

        Bx_tag({
            type: "x",
            class: "p-25 round theme-bg-lighten"
          }, out, __component, "6" + $keyScope$0);

        out.ee();
      }

      out.ee();
    });

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
